import { render, staticRenderFns } from "./BackButton.vue?vue&type=template&id=7395adb8&"
import script from "./BackButton.vue?vue&type=script&lang=ts&"
export * from "./BackButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports